import { styled } from 'styles/stitches.config'
import { rem } from 'polished'
import { Avatar as AvatarChakra } from "@chakra-ui/react";


export const Flex = styled('div', {

  '@lg': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  }
})

export const Left = styled('div', {
  flex: 1,
  marginBottom: 50,

  '@lg': {
    marginBottom: 0,
  },
})


export const Figure = styled('figure', {
  width: '100%',
  height: 400,
  marginBottom: 22,
  position: 'relative',

  borderRadius: 10,
  background: '#C4C4C4',
  overflow: 'hidden',

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',

  }
})

export const About = styled('div', {
  marginBottom: 48,

  '@md': {
    display: 'flex',
    justifyContent: 'space-between',
  }
})

export const Item = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginRight: 0,
  marginBottom: 10,

  '@md': {
    marginRight: 22,
    marginBottom: 0,
  },

  '&:last-of-type': {
    marginLeft: 'auto',
    marginRight: 0,
  }
})

export const AboutText = styled('p', {
  marginLeft: 8,

  color: '$grey600',
  fontFamily: '$manrope',
  fontSize: rem(12),
})

export const Text = styled('div', {
  '& p': {
    marginBottom: 22,
    
    fontFamily: '$raleway',
    fontSize: rem(13),
    color: '$grey600',
  },
  '& img': {
    
    margin: '0 auto',
    marginBottom: 22,
    border: "4px solid $white ",
    boxShadow: '0 0 8px rgba(0, 0, 0, 0.6)',
    cursor: 'pointer',
  },
})

export const Features = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: '14px',

  '&:not(:last-of-type)': {
    marginBottom: 48
  },

  '@sm': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },

  '& p': {
    marginLeft: 13,

    fontFamily: '$raleway',
    fontSize: rem(13),
    color: '$grey600',
  }
})

export const FeaturesItem = styled('div', {
  display: 'flex',
  alignItems: 'center',
})


export const Author = styled('div', {
  my: 50,

  '@sm': {
    display: 'flex',
    alignItems: 'center',
  },
})

export const AuthorRight = styled('div', {

  '@sm': {
    marginLeft: 20,
  },
})

export const AuthorImage = styled('div', {
  overflow: 'hidden',
  marginBottom: 10,
  borderRadius: '100%',
  position: 'relative',
  width: '120px',
  height: '120px',
  minWidth: '120px',
  minHeight: '120px',

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },

  '@lg': {
    marginBottom: 0,
  },
})

export const AuthorName = styled('p', {
  marginBottom: 10,

  fontFamily: '$domine',
  fontSize: rem(20),
  color: '$grey900'
})

export const AuthorDescription = styled('p', {
  fontFamily: '$raleway',
  fontSize: rem(13),
  color: '$grey600',
})

export const Share = styled('div', {
  marginBottom: 50,
})

export const ShareFlex = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',

  '&:not(:last-of-type)': {
    marginBottom: 10
  },

})

export const ShareSocials = styled('a', {
  width: 32,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  borderRadius: '100%',
  cursor: 'pointer',

  '&:not(:last-of-type)': {
    marginRight: 8
  },

  '&:hover': {
    opacity: 0.8
  },

  '&.facebook': {
    backgroundColor: '#2F80ED',
  },
  '&.twitter': {
    backgroundColor: '#56CCF2',
  },
})

export const ShareKeywords = styled('a', {
  padding: '4px 8px',
  display: 'block',
  marginBottom: 8,


  fontFamily: '$raleway',
  fontSize: rem(13),
  color: '$grey600',
  borderRadius: 4,
  background: '$emerald100',
  cursor: 'pointer',
  transition: 'all 0.3s',

  '&:hover': {
    background: '$emerald200',
    color: '$grey900',
    transition: 'all 0.3s',
  },

  '&:not(:last-of-type)': {
    marginRight: 8
  },
})


export const Comments = styled('div', {
  '& h4': {
    fontSize: '32px !important',
    marginBottom: 24,
  }
})


export const Right = styled('div', {
  flex: 1,

  border: 'solid 1px',
  borderColor: '$emerald500',
  borderRadius: 8,
  padding: '40px 24px',

  '& h4': {
    fontSize: '28px !important',
    marginBottom: 48,
  },

  '@lg': {
    marginLeft: 34,
    maxWidth: 400,
  },

  '@xxl': {
    marginLeft: 94,
  }
})


export const OthersTitle = styled("h6", {
  fontWeight: 'bold',
  fontSize: rem(15),
  color: '$grey900',
})

export const OthersBottom = styled('div', {
  marginTop: 8,
  paddingBottom: 8,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  borderBottom: 'solid 1px',
  borderColor: '$grey300',
})


export const Others = styled('a', {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',

  '&:not(:last-of-type)': {
    marginBottom: 40
  },

  '&:hover': {
    [`& ${OthersTitle}`]: {
      color: '$emerald500'
    },
    [`& ${OthersBottom}`]: {
      borderColor: '$emerald500'
    },
  }
})

export const OthersFigure = styled('figure', {
  width: 86,
  height: 86,
  marginRight: 16,

  borderRadius: 4,
  background: '#ccc',
  overflow: 'hidden',

  position:"relative",
  
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }
})

export const OthersRight = styled('div', {
  flex: 1,
})


export const OthersText = styled('time', {
  color: '$grey600',
  fontFamily: '$manrope',
  fontSize: rem(11),
})